import { filterRelationshipManagers, filterAccountManagers, filterLendingManagers } from '../helpers/adminRoleFilters'

describe('adminRoleFilters', () => {
  describe('filterRelationshipManagers', () => {
    it('should only return admins whose isRelationshipManager flag is true and whose isAccountManager and isLendingManager flags are false', () => {
      const admins = [
        { isRelationshipManager: true, isAccountManager: false, isLendingManager: false },
        { isRelationshipManager: false, isAccountManager: false, isLendingManager: false },
        { isAccountManager: true, isRelationshipManager: false, isLendingManager: false },
        { isRelationshipManager: true, isAccountManager: false, isLendingManager: true }
      ]
      const numRelationshipManagers = 1
      expect(filterRelationshipManagers(admins)).toHaveLength(numRelationshipManagers)
    })
  })
  describe('filterAccountManagers', () => {
    it('should only return admins whose isAccountManager flag is true and whose isRelationshipManager and isLendingManger flags are false', () => {
      const admins = [
        { isRelationshipManager: true, isAccountManager: false, isLendingManager: false },
        { isRelationshipManager: false, isAccountManager: false, isLendingManager: false },
        { isAccountManager: true, isRelationshipManager: false, isLendingManager: false },
        { isRelationshipManager: true, isAccountManager: false, isLendingManager: true },
        { isAccountManager: true, isRelationshipManager: false, isLendingManager: false }
      ]
      const numAccountManagers = 2
      expect(filterAccountManagers(admins)).toHaveLength(numAccountManagers)
    })
  })
  describe('filterLendingManagers', () => {
    it('should only return admins whose isLendingManager flag is true', () => {
      const admins = [
        { isRelationshipManager: true, isAccountManager: false, isLendingManager: true },
        { isRelationshipManager: false, isAccountManager: false, isLendingManager: false },
        { isAccountManager: true, isRelationshipManager: false, isLendingManager: false },
        { isRelationshipManager: true, isAccountManager: false, isLendingManager: true },
        { isAccountManager: true, isRelationshipManager: false, isLendingManager: false }
      ]
      const numLendingManagers = 2
      expect(filterLendingManagers(admins)).toHaveLength(numLendingManagers)
    })
  })
})
